import rest from "@/rest-client";

export const managementConfig = {
  moduleName: "managementConfig",
  namespaced: true,

  state: () => ({
    editedEntity: undefined,
    config: [],
    isUpdating: false,
    isLoading: false,
    loggedInAccounts: [],
  }),
  getters: {
    loggedInAccounts: (state) => state.loggedInAccounts,
    editedEntity: (state) => state.editedEntity ?? {},
    enableRecaptcha: (state) => state.config.enableRecaptcha,
    recaptchaKey: (state) => state.config.recaptchaKey,
    isLoading: (state) => state.isLoading,
    isUpdating: (state) => state.isUpdating,
    config: (state) => state.config ?? [],
  },
  mutations: {
    loggedInAccounts: (state, value) => (state.loggedInAccounts = value),
    editedEntity: (state, value) => (state.editedEntity = value),
    config: (state, value) => (state.config = value),
    isLoading: (state, value) => (state.isLoading = value),
    isUpdating: (state, value) => (state.isUpdating = value),
  },
  actions: {
    async update({ commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);
        const response = await rest.put(`/management/config`, { item: payload });

        await dispatch("list");
        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async list({ commit }) {
      commit("isLoading", true);
      try {
        const response = await rest.get(`/management/config`);
        commit("config", response.data);
        return response;
      } finally {
        commit("isLoading", false);
      }
    },
    async loggedInAccounts({ commit }) {
      try {
        const response = await rest.get(`/management/logged-in-accounts`);
        commit("loggedInAccounts", response.data);
        return response;
      } finally {
      }
    },
  },
};

export const clientConfig = {
  //whiteLabel persistent değil çünkü backend ws ile yalnızca enable ise gönderiliyor
  persistent: ["enableRecaptcha", "recaptchaKey"],
  moduleName: "clientConfig",
  namespaced: true,

  state: () => ({
    recaptchaKey: undefined,
    enableRecaptcha: undefined,
    whiteLabel: undefined,
    isUpdating: false,
    isLoading: false,
  }),
  getters: {
    recaptchaKey: (state) => state.recaptchaKey,
    whiteLabel: (state) => state.whiteLabel,
    enableRecaptcha: (state) => state.enableRecaptcha ?? false,
    isLoading: (state) => state.isLoading,
  },
  mutations: {
    recaptchaKey: (state, value) => (state.recaptchaKey = value),
    whiteLabel: (state, value) => (state.whiteLabel = value),
    enableRecaptcha: (state, value) => (state.enableRecaptcha = value),
    isLoading: (state, value) => (state.isLoading = value),
  },
  actions: {
    setConfig({ commit }, data) {
      commit("enableRecaptcha", data.enableRecaptcha);
      commit("recaptchaKey", data.recapchaKey);
      commit("whiteLabel", data.whiteLabel);
    },
  },
};
